import React from 'react';

const AboutPage = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="text-center mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">Doulos</h1>
          <p className="text-xl italic text-gray-600 mb-8">Welcome to the Doulos Experience!</p>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <div className="space-y-6 text-lg text-gray-700">
            <p>
              Looking for a sound beyond the mundane? Look no further than Doulos. Whether it is the high energy "Mystery", 
              the soul-searching "Time", or the cinematic experience of "Sand", our original songs are fresh and unique in a 
              sea of the ordinary.
            </p>
            <p>
              Weaved within our songs, you will catch glimpses of our musical influences; bands such as Led Zeppelin, Pink Floyd, 
              Rush, Yes, King's X, and Genesis, et al. In our performances, you will on occasion hear us cover songs from bands 
              like Foo Fighters, Stone Temple Pilots, Collective Soul, Pink Floyd, and others.
            </p>
            <p className="font-semibold text-xl text-center">
              Doulos... beyond the ordinary.
            </p>
            <p className="text-center text-sm text-gray-500">
              Doulos is an alternative/progressive rock band based out of Kansas City.
            </p>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8 mb-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Musical Influences</h2>
          <div className="grid md:grid-cols-2 gap-6">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Classic Progressive Rock</h3>
              <ul className="text-gray-700 space-y-1">
                <li>• Led Zeppelin</li>
                <li>• Pink Floyd</li>
                <li>• Rush</li>
                <li>• Yes</li>
                <li>• Genesis</li>
              </ul>
            </div>
            <div>
              <h3 className="text-lg font-semibold text-gray-900 mb-3">Modern Alternative</h3>
              <ul className="text-gray-700 space-y-1">
                <li>• King's X</li>
                <li>• Foo Fighters</li>
                <li>• Stone Temple Pilots</li>
                <li>• Collective Soul</li>
              </ul>
            </div>
          </div>
        </div>

        <div className="bg-white rounded-lg shadow-lg p-8">
          <h2 className="text-2xl font-bold text-gray-900 mb-6">Our Original Songs</h2>
          <p className="text-gray-700 mb-6">
            Our catalog features unique, original compositions that showcase our alternative/progressive rock style:
          </p>
          <div className="grid md:grid-cols-2 gap-4">
            <div className="border-l-4 border-blue-500 pl-4">
              <h4 className="font-semibold text-gray-900">"Mystery"</h4>
              <p className="text-gray-600 text-sm">High energy progressive rock</p>
            </div>
            <div className="border-l-4 border-blue-500 pl-4">
              <h4 className="font-semibold text-gray-900">"Time"</h4>
              <p className="text-gray-600 text-sm">Soul-searching introspective piece</p>
            </div>
            <div className="border-l-4 border-blue-500 pl-4">
              <h4 className="font-semibold text-gray-900">"Sand"</h4>
              <p className="text-gray-600 text-sm">Cinematic musical experience</p>
            </div>
            <div className="border-l-4 border-blue-500 pl-4">
              <h4 className="font-semibold text-gray-900">"Otherland"</h4>
              <p className="text-gray-600 text-sm">Alternative rock journey</p>
            </div>
            <div className="border-l-4 border-blue-500 pl-4">
              <h4 className="font-semibold text-gray-900">"Buckethead"</h4>
              <p className="text-gray-600 text-sm">Thought-provoking narrative</p>
            </div>
            <div className="border-l-4 border-blue-500 pl-4">
              <h4 className="font-semibold text-gray-900">"Against the Grain"</h4>
              <p className="text-gray-600 text-sm">Rebellious anthem</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutPage;